module.exports = __webpack_public_path__ + "static/media/insurance-mobile.aff71001.png";